import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useGetInstallerDashboardQuery } from "../api/apiSlice";
import { setsteps, setCurrentStep } from "./Stepper/stepperSlice";
import {
  BottomNav,
  ActiveJobCard,
  RecentJobCard,
} from "./InstallerLandingPage";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

function InstallsPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: dashboardData, isSuccess } = useGetInstallerDashboardQuery();

  const handleResume = (jobCard) => {
    const ref = jobCard.reference_id;
    const sn = jobCard.serial_number || "";
    const imsi = jobCard.imsi_number || "";
    const archSn = jobCard.archived_serial_number || "";
    const archImsi = jobCard.archived_imsi_number || "";

    if (jobCard.install_state === "NEW") {
      dispatch(setsteps([0, 1, 2, 3, 4, 5]));
      if (jobCard.state === "QRC") {
        dispatch(setCurrentStep(1));
        navigate(`/installer/${ref}/qrcode/`);
      } else if (jobCard.state === "BEFWA" || jobCard.state === "BEF") {
        dispatch(setCurrentStep(2));
        navigate(`/installer/${ref}/${sn}/${imsi}/work_area_before_install/`);
      } else if (jobCard.state === "AMP") {
        dispatch(setCurrentStep(3));
        navigate(`/installer/${ref}/${sn}/${imsi}/connection_test_interlude/`);
      } else if (jobCard.state === "TES") {
        dispatch(setCurrentStep(4));
        navigate(`/installer/${ref}/${sn}/${imsi}/connection_test/`);
      } else if (jobCard.state === "AFT" || jobCard.state === "AFTWA") {
        dispatch(setCurrentStep(5));
        navigate(`/installer/${ref}/${sn}/${imsi}/after_install/`);
      } else if (jobCard.state === "REF") {
        navigate(`/installer/${ref}/${sn}/${imsi}/job_completed/`);
      }
    } else if (jobCard.install_state === "UN") {
      dispatch(setsteps([0, 1, 2, 3]));
      if (jobCard.state === "BEFWA" || jobCard.state === "BEF") {
        dispatch(setCurrentStep(1));
        navigate(`/installer/${ref}/${archSn}/${archImsi}/work_area_before_install/`);
      } else if (jobCard.state === "UNI") {
        dispatch(setCurrentStep(2));
        navigate(`/installer/${ref}/${archSn}/${archImsi}/UN/`);
      } else if (jobCard.state === "AFT" || jobCard.state === "AFTWA") {
        dispatch(setCurrentStep(3));
        navigate(`/installer/${ref}/${archSn}/${archImsi}/after_install/`);
      } else if (jobCard.state === "REF") {
        navigate(`/installer/${ref}/${archSn}/${archImsi}/job_completed/`);
      }
    } else if (jobCard.install_state === "RE") {
      dispatch(setsteps([0, 1, 2, 3, 4, 5, 6, 7]));
      if (jobCard.state === "BEFWA" || jobCard.state === "BEF") {
        dispatch(setCurrentStep(1));
        navigate(`/installer/${ref}/${archSn}/${archImsi}/work_area_before_install/`);
      } else if (jobCard.state === "UNI") {
        dispatch(setCurrentStep(2));
        navigate(`/installer/${ref}/${archSn}/${archImsi}/RE/`);
      } else if (jobCard.state === "QRCRE") {
        dispatch(setCurrentStep(3));
        navigate(`/installer/${ref}/qrcode/replacement/`);
      } else if (jobCard.state === "DET") {
        dispatch(setCurrentStep(4));
        navigate(`/installer/${ref}/${sn}/${imsi}/details/`);
      } else if (jobCard.state === "AMP") {
        dispatch(setCurrentStep(5));
        navigate(`/installer/${ref}/${sn}/${imsi}/connection_test_interlude/`);
      } else if (jobCard.state === "TES") {
        dispatch(setCurrentStep(6));
        navigate(`/installer/${ref}/${sn}/${imsi}/connection_test/`);
      } else if (jobCard.state === "AFT" || jobCard.state === "AFTWA") {
        dispatch(setCurrentStep(7));
        navigate(`/installer/${ref}/${sn}/${imsi}/after_install/`);
      } else if (jobCard.state === "REF") {
        navigate(`/installer/${ref}/${sn}/${imsi}/job_completed/`);
      }
    }
  };

  const activeJobs = isSuccess ? dashboardData.active_jobs : [];
  const recentCards = isSuccess ? dashboardData.recent_cards : [];

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          pt: 2.5,
          pb: 2,
        }}
      >
        <Box
          onClick={() => navigate("/installer/")}
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            backgroundColor: "rgba(255,255,255,0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.7)" }} />
        </Box>
        <Typography sx={{ fontSize: "1.2rem", fontWeight: 700, color: "#fff" }}>
          My Installs
        </Typography>
      </Box>

      {/* In progress */}
      {activeJobs.length > 0 && (
        <Box sx={{ px: 2, mb: 1 }}>
          <Typography
            sx={{
              fontSize: "0.65rem",
              fontWeight: 600,
              color: "rgba(255,255,255,0.4)",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              mb: 1.5,
            }}
          >
            In Progress
          </Typography>
          {activeJobs.map((job) => (
            <ActiveJobCard
              key={job.reference_id}
              job={job}
              onResume={handleResume}
              disabled={false}
            />
          ))}
        </Box>
      )}

      {/* Completed / QEP */}
      <Box sx={{ px: 2, mt: activeJobs.length > 0 ? 1 : 0 }}>
        {recentCards.length > 0 ? (
          <>
            <Typography
              sx={{
                fontSize: "0.65rem",
                fontWeight: 600,
                color: "rgba(255,255,255,0.4)",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                mb: 1.5,
              }}
            >
              Submitted
            </Typography>
            {recentCards.map((job) => (
              <RecentJobCard key={job.reference_id} job={job} />
            ))}
          </>
        ) : (
          !isSuccess && (
            <Typography sx={{ color: "rgba(255,255,255,0.3)", fontSize: "0.85rem", textAlign: "center", mt: 6 }}>
              Loading…
            </Typography>
          )
        )}
        {isSuccess && recentCards.length === 0 && activeJobs.length === 0 && (
          <Typography sx={{ color: "rgba(255,255,255,0.3)", fontSize: "0.85rem", textAlign: "center", mt: 8 }}>
            No installs yet
          </Typography>
        )}
      </Box>

      {/* Spacer for bottom nav */}
      <Box sx={{ height: "80px" }} />

      <BottomNav active="installs" />
    </>
  );
}

export default React.memo(InstallsPage);
